import { A11yModule, FocusOrigin } from '@angular/cdk/a11y';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  signal,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { MatExpansionModule, MatExpansionPanelHeader } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { TranslocoModule } from '@jsverse/transloco';
import { RmaIconComponent } from '@rma/generic/ui/icon';

import { NavigationMenu } from '../domain/entities/side-nav-items';
import { NavMenuItemComponent } from '../ui-nav-menu-item/nav-menu-item.component';
import { IsNavMenuItemActivePipe } from '../util-is-nav-menu-item-active/is-nav-menu-item-active.pipe';

@Component({
  selector: 'rma-sub-menu',
  templateUrl: './sub-menu.component.html',
  styleUrls: ['./sub-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    A11yModule,
    IsNavMenuItemActivePipe,
    MatExpansionModule,
    MatListModule,
    NavMenuItemComponent,
    RmaIconComponent,
    TranslocoModule,
  ],
})
export class SubMenuComponent implements OnChanges {
  @Input({ required: true })
  public item!: NavigationMenu;

  @Input({ required: true })
  public menuActive = false;

  @Input({ required: true })
  public currentUrl!: string;

  @HostBinding('class.collapsed')
  @Input()
  public collapsed = false;

  @Output()
  public navigated = new EventEmitter<void>();

  @Output()
  public menuExpanded = new EventEmitter<string>();

  protected expanded = signal<boolean>(false);

  ngOnChanges(changes: SimpleChanges): void {
    const { menuActive, collapsed } = changes;

    if (collapsed && this.collapsed) {
      this.onClosed();
    }

    if (menuActive && this.menuActive) {
      this.onOpened();
    }
  }

  protected onOpened() {
    this.expanded.set(true);
    this.menuExpanded.emit(this.item.label);
  }

  protected onClosed() {
    this.expanded.set(false);
  }

  protected onFocus(event: FocusOrigin, header: MatExpansionPanelHeader) {
    if (event === 'keyboard') {
      if (!header.panel.expanded && !this.collapsed) {
        header.panel.open();
      }
    }
  }
}
